import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import { setCategoria, setPaginaFiltros } from '../../slices/filterSlice'
import * as subcategoriaService from '../servicios/subcategoriaService'
import styles from './Subcategorias.module.css'

const Subcategorias = () => {
  const { idCategoria, descripcion } = useParams()
  const [subCategorias, setSubCategorias] = useState([])
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchData = async () => {
      const { data: subCategorias } =
        await subcategoriaService.buscarTodosPorIdCategoria(idCategoria)

      if (subCategorias.length === 0) {
        navigate('/Publicaciones', { state: { desdeCategoria: true } })
        return
      }

      setSubCategorias(subCategorias)
    }

    fetchData()
  }, [idCategoria])

  const handleClick = (e) => {
    dispatch(setCategoria({ id: Number(e.idSubCategoria), label: e.descripcion }))
    dispatch(setPaginaFiltros(e.tieneSubCategoria !== 0 && '/SubCategorias'))

    if (e.tieneSubCategoria === 0) {
      navigate('/Publicaciones', { state: { desdeCategoria: true } })
    } else {
      navigate(`/SubCategorias/${e.idSubCategoria}/${e.descripcion}`)
    }
  }

  return (
    <fieldset className={styles.fieldset}>
      <legend>{descripcion}</legend>
      <div className={styles.grid}>
        {subCategorias.map((e) => (
          <div key={e.idSubCategoria} className={styles.card} onClick={() => handleClick(e)}>
            <span className={styles.label}>{e.descripcion}</span>
          </div>
        ))}
      </div>
    </fieldset>
  )
}

export default Subcategorias
